import styled from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

const NUDGE_MIN_HEIGHT_PX = 44;

export const Root = styled.div(({ theme }) => ({
    display: "flex",
    flexDirection: "row" as const,
    alignItems: "center",
    justifyContent: "flex-start",
    boxSizing: "border-box" as const,
    minHeight: NUDGE_MIN_HEIGHT_PX,
    gap: theme.spacing.xxSmall,
    padding: theme.spacing.xSmall,
    borderRadius: theme.cornerRadius.xSmall,
    backgroundColor: theme.colors[theme.colorMode].positive_Sub,
    margin: `${theme.spacing.xSmall} 0px 0px calc(-1 * (${theme.spacing.medium} + ${theme.spacing.small}))`,
}));

export const NudgeText = styled(Text)({
    flex: 1,
    margin: 0,
    textAlign: "left" as const,
});

export const LogoWrap = styled.div(({ theme }) => ({
    flexShrink: 0,
    width: theme.spacing.large,
    height: theme.spacing.large,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "& img": {
        width: theme.spacing.large,
        height: theme.spacing.large,
        maxWidth: theme.spacing.large,
        maxHeight: theme.spacing.large,
        objectFit: "contain" as const,
        display: "block",
    },
}));
